import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useClientBranding } from '../contexts/ClientBrandingContext';
import { brandedHomePath } from '../utils/brandedHomePath';
import { hasPartnerSession, PARTNER_APP_HOME } from '../utils/partnerWorkspace';
import Home from '../pages/Home';

export { brandedHomePath };

const BrandedHomeGate = () => {
  const { user, loading } = useAuth();
  const { branding } = useClientBranding();
  if (hasPartnerSession()) {
    return <Navigate to={PARTNER_APP_HOME} replace />;
  }
  if (loading) return null;
  const destination = brandedHomePath(branding, Boolean(user));
  if (destination) {
    return <Navigate to={destination} replace />;
  }
  return <Home />;
};

export default BrandedHomeGate;
